const SERVICE_NAMES = {
	POSTHOG: "postHog",
	MOENGAGE: "moEngage",
	GOOGLEANALYTICS: "gtm",
	CLARITY: "clarity",
};

export default SERVICE_NAMES;
